import { HStack, Select } from '@chakra-ui/react'
import moment from 'moment'

interface Props {
  value: string // YYYY-MM format
  onChange: (value: string) => void
  disabled?: boolean
}

export default function MonthYearPicker({ value, onChange, disabled }: Props) {
  // Parse current value or default to current month
  const [currentYear, currentMonth] = value
    ? value.split('-')
    : [moment().format('YYYY'), moment().format('MM')]

  // Generate year range (current year + 1 to 10 years ago)
  const startYear = parseInt(moment().format('YYYY')) + 1
  const endYear = parseInt(moment().format('YYYY')) - 10
  const years = arrayRange(endYear, startYear, 1)

  const handleYearChange = (newYear: string) => {
    if (newYear && currentMonth) {
      onChange(`${newYear}-${currentMonth}`)
    }
  }

  const handleMonthChange = (newMonth: string) => {
    if (currentYear && newMonth) {
      onChange(`${currentYear}-${newMonth}`)
    }
  }

  return (
    <HStack>
      <Select
        maxWidth={100}
        value={currentYear}
        onChange={(e) => handleYearChange(e.target.value)}
        isDisabled={disabled}
      >
        <option value=''>Year</option>
        {years.reverse().map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </Select>
      <Select
        maxWidth={140}
        value={currentMonth}
        onChange={(e) => handleMonthChange(e.target.value)}
        isDisabled={disabled}
      >
        {months.map((month, index) => {
          if (index === 0) return null // Skip "Month" placeholder
          const monthValue = index < 10 ? `0${index}` : `${index}`
          return (
            <option key={index} value={monthValue}>
              {month}
            </option>
          )
        })}
      </Select>
    </HStack>
  )
}

function arrayRange(start: number, stop: number, step: number) {
  return Array.from(
    { length: (stop - start) / step + 1 },
    (value, index) => start + index * step
  )
}

const months = [
  'Month',
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]
